module.exports = __webpack_public_path__ + "img/ilo.ba804bba.svg";